
const SET_PROFILE = 'SET_PROFILE'
const GET_PROFILE = 'GET_PROFILE'
const PASSWORD_CHANGE_SUCCESS = 'PASSWORD_CHANGE_SUCCESS'
const PASSWORD_CHANGE_FAIL = 'PASSWORD_CHANGE_FAIL'


export const defaultProfileState =  {
  profile: null,
  error: null,
  errorMessage: null
}

export default (state = defaultProfileState, action) => {
  switch (action.type) {
    case SET_PROFILE:
      return {
        ...state,
        profile: action.profile
      }
    case GET_PROFILE:
      return {
        ...state,
      }
    case PASSWORD_CHANGE_SUCCESS: {
      if (action.payload.data.success) {
        return {
          ...state,
          error: false,
          errorMessage: null
        }
      } else {
        return {
          ...state,
          errorMessage: action.payload.data.errors,
          error: true
        }
      }
    }
    case PASSWORD_CHANGE_FAIL: {
      return {
        ...state,
      }
    }
    default:
      return state
  }
}
